import $ from "jquery";
import { ViewContactByAPI } from "#scripts/contact_functions";
import { compileResources } from "#scripts/compile";
import { decodeIfNeeded } from "#templates/pages/content";
import { skjemaLink } from "#scripts/skjema";
import { setImages } from "#scripts/images";
import { createGallery } from "#scripts/create_gallery";
import { tableResponsive } from "#scripts/table";
import { setAccordian } from "#scripts/accordian";
import language from "#scripts/translation";
import { customAlphabet } from "nanoid/non-secure";

export const createNanoId = () => {
	const nanoid = customAlphabet("0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz", 5);
	return nanoid(); // => "4f90d13a42"
};

export const createGuid = () => {
	return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
		const r = (Math.random() * 16) | 0;
		const v = c === "x" ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
};

export const isGuid = (guid) => {
	let s = `${guid}`;
	s = s.match("^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$");
	return s === null;
};

export const isValidGUID = (str) => {
	const guidRegex = /^[{]?[0-9a-fA-F]{8}(-[0-9a-fA-F]{4}){3}-[0-9a-fA-F]{12}[}]?$/;
	return guidRegex.test(str);
}

export const setVariable = (_content, variables) => {
	const regex = /({{(?:link-|setting-)?)(\w+)(}})/gim;
	const variablesOnPage = _content.match(regex);
	let variablesOnPageLog = {};
	if (variablesOnPage) {
		for (const val of variablesOnPage) {
			variablesOnPageLog[val] = "Found";
		}
	} else {
		variablesOnPageLog = "";
	}

	let content = _content.replace(regex, "$2");

	$.each(variablesOnPage, function () {
		const currVar = this.replace(regex, "$2");
		if (variables.find((i) => i.Key === currVar) === undefined) {
			console.info(`%cVariable "${currVar}" not found`, "font-size: 1rem; color: #001530; background: #a7ceff;");
			content = content.replace(currVar, `<span class='replace__variable unknown__variable'>${currVar}</span>`);
			variablesOnPageLog[this] = "Not found";
		}
	});
	$.each(variables, function () {
		const vari = $(this)[0];
		const re = new RegExp(vari.Key, "g");
		let replaceWith = "";

		if (vari.isRelevantAvailable) {
			if (!vari.isRelevant) {
				replaceWith = "<span class='replace__variable disabled__variable'></span>";
				content = content.replace(re, replaceWith);
				return;
			}
		}

		const selectedLanguage = vari.languages.find((lang) => lang.cultureNameShort === window.serverdata.configMeta.aim.lang); //.displayAsButton;
		const displayAsButton = (selectedLanguage && selectedLanguage?.displayAsButton !== "" && selectedLanguage?.displayAsButton !== undefined) ? `btn btn-${selectedLanguage?.displayAsButton.toLowerCase()}` : "";

		// const urlPattern = /^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.*[a-z0-9-]+)+(\.[a-z]{2,})(\/[^\s]*)?$/i;
		const urlPattern = /^(https?:\/\/)?(www\.)?[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}([/?#]\S*)?$/i;
		// const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/gim
		const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		if (urlPattern.test(vari.Value)) {
			const name = vari.DisplayName || vari.Value || "";
			let href = ` href="${vari.Value}"`;
			if (vari.Value.match(/^http/gim)) {
				href = ` href="${vari.Value}" aria-label="${name} (${language("NAV_OPEN_I_NEW")})" target="_blank"`;
			}
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}" ${href}>${name}</a>`;
		} else if (emailPattern.test(vari.Value)) {
			replaceWith = `<a class="replace__variable replace__variable__link replace__variable__link-email" href="mailto:${vari.Value}">${vari.Value}</a>`;
		} else if (vari.Value.match(/aim:skjema-inline:/gim)) {
			replaceWith = `<div data-skjemaid='${vari.Value.split(":")[1]}' data-skjemanavn="${vari.DisplayName}" id="inline-skjema" class="inlineform__container"></div>`;
		} else if (vari.Value.match(/aim:skjema:/gim)) {
			const name = vari.DisplayName || vari.Value || "";
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}"  href="${vari.Value}" data-origurl="${vari.Value}">${name}</a>`;
		} else if (vari.Value.match(/aim:/gim)) {
			const name = vari.DisplayName || vari.Value || "";
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}"  href="${vari.Value}">${name}</a>`;
		} else if (vari.Value.match(/skjema:/gim)) {
			const name = vari.DisplayName || vari.Value || "";
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}"  href="${vari.Value}">${name}</a>`;
		} else if (vari.Value.match(/skjema-inline:/gim)) {
			replaceWith = `<div data-skjemaid='${vari.Value.split(":")[1]}' data-skjemanavn="${vari.DisplayName}" id="inline-skjema" class="inlineform__container"></div>`;
		} else {
			replaceWith = `<span class='replace__variable'>${vari.Value}</span>`;
		}
		// check if it is a variable in a href
		if (content.includes(` href="${re.source}" `)) {
			content = content.replace(re, vari.Value);
		} else {
			content = content.replace(re, replaceWith);
		}
	});

	return content;
};

export const setVariableNew = (_content, variables) => {
	const regex = /({{link-|{{setting-|{{)([\w]*)(}})/gim;
	const variablesOnPage = _content.match(regex);
	const variablesOnPageLog = variablesOnPage ? Object.fromEntries(variablesOnPage.map(val => [val, "Found"])) : "";

	let content = _content.replace(regex, "$2");

	variablesOnPage.forEach(val => {
		const currVar = val.replace(regex, "$2");
		if (!variables.some(i => i.Key === currVar)) {
			console.info(`%cVariable "${currVar}" not found`, "font-size: 1rem; color: #001530; background: #a7ceff;");
			content = content.replace(currVar, `<span class='replace__variable unknown__variable'>${currVar}</span>`);
			variablesOnPageLog[val] = "Not found";
		}
	});

	variables.forEach(vari => {
		const re = new RegExp(vari.Key, "g");
		let replaceWith = "";

		if (vari.isRelevantAvailable && !vari.isRelevant) {
			replaceWith = "<span class='replace__variable disabled__variable'></span>";
			content = content.replace(re, replaceWith);
			return;
		}

		const selectedLanguage = vari.languages.find(lang => lang.cultureNameShort === window.serverdata.configMeta.aim.lang);
		const displayAsButton = selectedLanguage ? `btn btn-${selectedLanguage.displayAsButton.toLowerCase()}` : "";

		if (/^(https?:\/\/|www\.)/i.test(vari.Value)) {
			const name = vari.DisplayName || vari.Value || "";
			const href = vari.Value.startsWith("http"

			) ? ` href="${vari.Value}" aria-label="${name} (${language("NAV_OPEN_I_NEW")})" target="_blank"` : ` href="${vari.Value}"`;
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}" ${href}>${name}</a>`;
		} else if (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+@/.test(vari.Value)) {
			replaceWith = `<a class="replace__variable replace__variable__link replace__variable__link-email" href="mailto:${vari.Value}">${vari.Value}</a>`;
		} else if (/aim:skjema-inline:/.test(vari.Value)) {
			replaceWith = `<div data-skjemaid='${vari.Value.split(":")[1]}' data-skjemanavn="${vari.DisplayName}" id="inline-skjema" class="inlineform__container"></div>`;
		} else if (/aim:|skjema:/.test(vari.Value)) {
			const name = vari.DisplayName || vari.Value || "";
			replaceWith = `<a class="replace__variable replace__variable__link ${displayAsButton}" href="${vari.Value}">${name}</a>`;
		} else {
			replaceWith = `<span class='replace__variable'>${vari.Value}</span>`;
		}

		content = content.includes(` href="${re.source}" `) ? content.replace(re, vari.Value) : content.replace(re, replaceWith);
	});

	return content;
};

export const setLists = (clientid, _content) => {
	const content = $(`<class="me">${_content}</div>`);
	content.find(".content_list").each(function (obj) {
		const elmId = createGuid();
		const data = $(this).data();
		const start = data.start || 0;

		$(this).attr("id", elmId);
		$(this).html(`<span class='content__wait'>${language("GENERAL_LOADING")} ...</span>`);
		const apiFunction = data.orderby_dir === "ASC" ? "getcontentlist" : "getcontentlistdescending";
		$.getJSON(`${window.apiUrl}/PublicContentApi/${apiFunction}/${clientid}/${data.listtype}/${data.maxnumber}/${start}/${data.orderby}`).done((result) => {
			const elm = [];

			$.each(result.listOfContent, (a, b) => {
				elm.push(`
                <div class="listelement">
                    <h2 class="list__header">
                        <a href="/article/${b.contentId}" class="list__link">${b.title}</a>
                    </h2>
                    <p class="list__intro">${b.intro}</p>
                </div>`);
			});

			const r = `<div class='inline-load-list'>${elm.join("")}</div>`;

			$(`#${elmId}`).html(r);
		});
	});

	return content.html();
};

export const removeExtraSpace = (content) => {
	const regex = /<p>&nbsp;<\/p>/gi;
	return content.replace(regex, "");
};

export const checkNested_old = (obj, level, ...rest) => {
	if (obj === undefined) return false;
	if (rest.length === 0 && Object.hasOwn(obj, level)) {
		return true;
	}
	return checkNested(obj[level], ...rest);
};

export const checkNested = (obj, level, ...rest) => {
	const hasOwn = (o, key) =>
		typeof Object.hasOwn === 'function'
			? Object.hasOwn(o, key)
			: Object.prototype.hasOwnProperty.call(o, key);

	if (obj === undefined || obj === null) return false;

	if (rest.length === 0) {
		return hasOwn(obj, level);
	}

	if (!hasOwn(obj, level)) {
		return false;
	}

	return checkNested(obj[level], ...rest);
};

export const getConfig = () => {
	const json = JSON.parse(sessionStorage.getItem("config"));
	return json;
};

export const getRelations = (data, relationType = "") => {
	const relations = [];
	const nofRelations = data.length;

	// Sort list if it has a title
	if (data[0].title !== undefined) {
		data.sort((a, b) => a.title.localeCompare(b.title, "no"));
	}

	$.each(data, (nr, relation) => {
		if (relation.pageTypeId === undefined && relation.title !== undefined) {
			relations.push(`
              <div class="article__keyinfo">
                  <div class="contact_cards Xtext-truncate" id="${relation.id}">
                      <a href="/artikkel/${relation.id}">${relation.title}</a>
                  </div>
              </div>`);
		}

		const apiCall = `${window.apiUrl}/Public/articles/${relation.id}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&includeCategories=true&getRecursiveContent=true`;
		$.getJSON(apiCall).done((data) => {
			if (data.found === false) { return; }
			if (data.pageTypeId === "mal_visittkort") {
				const meta = data.metaObject || false;
				const contact = JSON.parse(decodeURIComponent(meta));
				const mobile = contact.personMobil.length > 0 ? `<a href="tel:${contact.personMobil}">${contact.personMobil}</a>` : "";
				const personTelefon = contact.personTelefon.length > 0 ? `<a href="tel:${contact.personTelefon}">${contact.personTelefon}</a>` : "";
				const phone = mobile !== "" || personTelefon !== "" ? `<p>Telefon:<br/>${mobile} ${personTelefon}</p>` : "";
				const title = contact.personStilling.length > 0 ? `<p>${contact.personStilling}</p>` : "";
				const department = contact.personAvdeling.length > 0 ? `<p>${contact.personAvdeling}</p>` : "";
				let linkPrefix = "mailto:";
				let linkDisplayName = contact.personEpost;
				let target = "";
				if (contact?.personEpost.startsWith("http")) {
					linkPrefix = "";
					linkDisplayName = language("CONTACT_CONTACT_LINK");
					target = ` aria-label="${language("CONTACT_CONTACT_LINK")} (${language("NAV_OPEN_I_NEW")})" target=_blank`;
				}
				const email =
					contact.personEpost.length > 0 ? `<p>E-post:<br/> <a href="${linkPrefix + contact.personEpost}"${target} class="text-truncate">${linkDisplayName}</a></p>` : "";
				const name = contact.personNavn.length > 0 ? `<span class="contact__card__name">${contact.personNavn}</span>` : "";
				const text = contact.personFritekst ? `<p>${contact.personFritekst}</p>` : "";

				$("#contact__relations").append(`
                  <div class="article__keyinfo">
                      <h2>Kontakt</h2>
                      <div class="contact_cards Xtext-truncate">
                          ${name}
                          ${title}
                          ${department}
                          ${phone}
                          ${email}
                          ${text}
                      </div>
                  </div>`);
			} else if (data.pageTypeId === "mal_enhetsmal") {
				// Add the unit that is not already added to page
				if (document.getElementById(data.contentId) === null) {
					$("#unit__relations").append(`
              <div class="article__keyinfo">
                  <div id="${data.contentId}">
                      <a href="/artikkel/${data.contentId}">${data.title}</a>
                  </div>
              </div>`);
				}
			} else if (data.pageTypeId === "mal_dynamisk") {
				const meta = data.metaObject || false;
				const contact = JSON.parse(decodeURIComponent(meta));

				ViewContactByAPI(contact, "", "", "right");
			} else {
				let content = data.contentObject;

				content = decodeIfNeeded(content);
				content = compileResources(content, data.relatedContentObjects);
				content = removeExtraSpace(content);
				content = tableResponsive(content).innerHTML;
				content = setImages(content);
				content = content.replace(/href="aim:/gim, 'href="/artikkel/');
				content = setAccordian(content);
				content = skjemaLink(content);
				content = content.replace(/h5/gim, "h6");
				content = content.replace(/h4/gim, "h5");
				content = content.replace(/h3/gim, "h4");
				content = content.replace(/h2/gim, "h3");

				$(".article__content").append(`<div class="externalrelation">
										<h2 id="${urlify(data?.title.trim())}">${data?.title}</h2>
										${content}
								</div>
								`);
				// Add title to TOC
				const titleText = data.title.trim();
				const anchor = urlify(titleText);

				if (!$(".article__toc")[0]) {
					// TOC does not exist so we must check if we will go ower the minimum number of headings before displaying toc
					const minNofHeadings = Number.parseInt(window.serverdata.configMeta.aim.articleTocMinHeadings);
					let toc = "";
					const minLevel = 2;
					const maxLevel = 2;
					const contentDom = new DOMParser().parseFromString($(".article__content").html(), "text/html");
					const headers = contentDom.querySelectorAll(
						`
              h1:not(.accordian h1):not(.bti__level__button h1):not(.bti__button h1):not(.bti__step__content h1), 
              h2:not(.accordian h2):not(.bti__level__button h2):not(.bti__button h2):not(.bti__step__content h2), 
              h3:not(.accordian h3):not(.bti__level__button h3):not(.bti__button h3):not(.bti__step__content h3) ,
              h4:not(.accordian h4):not(.bti__level__button h4):not(.bti__button h4):not(.bti__step__content h4), 
              h5:not(.accordian h5):not(.bti__level__button h5):not(.bti__button h5):not(.bti__step__content h5), 
              h6:not(.accordian h6):not(.bti__level__button h6):not(.bti__button h6):not(.bti__step__content h6)`,
					);

					for (const h of headers) {
						if (h.innerHTML !== "&nbsp;" && h.tagName.substr(1, 1) >= minLevel && h.tagName.substr(1, 1) <= maxLevel) {
							const titleText = h.innerText;
							const anchor = urlify(titleText.trim());
							toc += `<li><a class="toc__link" href="#${anchor}">${titleText}</a></li>`;
							h.id = anchor;
						}
					}

					if (toc.match(/<li>/g).length + nofRelations >= minNofHeadings) {
						content = contentDom.body.innerHTML;
						if (toc !== "" && toc.match(/<li>/g).length >= minNofHeadings) {
							content = `<ul class="article__toc">${toc}</ul>${content}`;
							$(".article__content").html(content);
						}
					}
				} else {
					const toc = `<li><a class="toc__link" href="#${anchor}">${titleText}</a></li>`;
					$(".article__toc").append(toc);
				}
				createGallery();
			}
		});
	});

	let elementId = `${relationType}__relations`;
	if (document.getElementById(elementId) !== null) {
		elementId = `${elementId}_1`;
	}
	return `<div class="article" id="${elementId}">
            ${relations.join("")}
          </div>`;
};

export const contentMeta = (item) => {
	const meta = item?.metaObject || false;

	if (meta !== "undefined") {
		return JSON.parse(decodeURIComponent(meta));
	}
};

export const testDynData = (meta, objname, value) => {
	let r = false;
	if (meta.currentDynamiskMalContent) {
		for (const obj of meta.currentDynamiskMalContent) {
			if (obj[objname] === value) {
				r = true;
			}
		}
	}

	return r;
};

export const getDynDataOne = (meta, name, objname = "title") => {
	/// / skal skrives ut.
	const result = meta.currentDynamiskMalContent.filter((obj) => {
		return obj[objname].match(name); // fjernet urlify
	});

	return result[0];
};

export const getDynData = (meta, selectone = false) => {
	// erstatter getDynDataOne && testDynData
	const result = {};
	const checks = [];

	if (meta.currentDynamiskMalContent && Array.isArray(meta.currentDynamiskMalContent)) {
		for (const obj of meta.currentDynamiskMalContent) {
			if (obj.title) {
				if (!selectone) {
					result[urlify(obj.title)] = obj.value; // fjernet urlify
					checks.push(true);
				} else if (urlify(obj.title) === selectone && obj.value.length > 0) {
					result.res = obj.value;
					checks.push(true);
				} else {
					checks.push(false);
				}
			}
			if (obj.localId) {
				if (!selectone) {
					result[obj.localId] = obj.value;
					checks.push(true);
				} else if (obj.localId === selectone && obj.value.length > 0) {
					result.res = obj.value;
					checks.push(true);
				} else {
					checks.push(false);
				}
			}
		}
	}

	if (checks.indexOf(true) >= 0) {
		return result;
	}
	return { res: false };
};

export const getContent = (contentId, clientId = window.serverdata.configMeta.aim.clientId) => {
	let apiLang = "nb_no";
	switch (window.serverdata.configMeta.aim.lang) {
		case "nb":
		case "nn":
			apiLang = `${window.serverdata.configMeta.aim.lang}_no`;
			break;
		case "en":
			apiLang = "en_us";
			break;
	}
	apiLang = localStorage.getItem("currentLanguage") || apiLang;

	let apiCall = `${window.apiUrl}/Public/articles/${contentId}`;
	let apiParameters = `?subscriptionId=${clientId}&language=${apiLang}&includeCategories=true&getRecursiveContent=true`;
	const ajaxCall = { type: "get", url: apiCall + apiParameters };
	if (window.getUrlAttr("preview") === "true") {
		apiCall = `${window.apiUrl}/ContentApi/articles/${contentId}?subscriptionId=${window.serverdata.configMeta.aim.clientId}`;
		// apiCall = `${window.apiUrl}/ContentApi/find/${contentId}/preview`;
		apiParameters = "";
		ajaxCall.url = apiCall + apiParameters;
		ajaxCall.headers = {
			Authorization: `Bearer ${localStorage.getItem("access_token")}`,
			subscriptionId: window.serverdata.configMeta.aim.clientId,
		};
	}
	return $.ajax(ajaxCall);
	// return $.getJSON(apiCall + apiParameters);
};

export const UpdateQueryString = (key, value) => {
	const params = new parent.URLSearchParams(parent.location.search);
	if (params.has(key)) {
		params.set(key, value);
	} else {
		params.append(key, value);
	}

	if (window.history.pushState) {
		const newURL = new URL(window.location.href);
		newURL.search = `?${params.toString()}`;
		window.history.pushState({ path: newURL.href }, "", newURL.href);
	}
};

export const getRelatedBlocks = (article, type) => {
	if (!article.relatedSubscriberContents || !article.relatedSubscriberContents.length) {
		return []; // Early exit if no data
	}

	const { relatedSubscriberContents } = article;

	const rel = JSON.parse(decodeURIComponent(relatedSubscriberContents));

	const contacts = [];
	const blocks = [];
	const units = [];

	for (const relatedContent of rel) {
		const { type: contentType, relations } = relatedContent;

		for (const item of relations) {
			const { contentId } = item;

			if (contentType === "mal_visittkort") {
				contacts.push({ id: contentId });
			} else if (contentType === "mal_blokk") {
				blocks.push({ id: contentId });
			} else if (contentType === "mal_enhetsmal") {
				units.push({ id: contentId });
			}
		}
	}

	switch (type) {
		case "block":
			return blocks;
		case "contact":
			return contacts;
		case "unit":
			return units;
		default:
			return []; // Handle unknown type gracefully
	}
};

export const adjustVariables = (variables) => {
	const lang = localStorage?.getItem("currentLanguage")?.substring(0, 2) || window.serverdata.configMeta.aim.lang || "nb";

	for (const item of variables) {
		item.Key = item.key;
		if (item.languages) {
			let itemLang = item.languages.find((obj) => {
				return obj.cultureNameShort.startsWith(lang);
			});
			itemLang = itemLang !== undefined ? itemLang : item.languages[0];
			if (item.languages.length > 0) {
				item.DisplayName = itemLang.displayName;

				if (itemLang.value) {
					item.Value = itemLang.value;
				} else {
					item.Value = "";
				}
			}
		}
	}

	return variables;
};

export const urlParseCheck = (_content) => {
	let content = _content;
	// let formlink = "/skjema/";
	const formlink = window.serverdata.configMeta.aim?.skjema?.url ? window.serverdata.configMeta.aim?.skjema?.url : "/skjema/";

	// if (window.serverdata.configMeta.aim.skjema) {
	// 	if (window.serverdata.configMeta.aim.skjema.url) {
	// 		formlink = window.serverdata.configMeta.aim.skjema.url;
	// 	}
	// }

	if (content.match(/aim:skjema:/gim)) {
		content = content.replace(/aim:skjema:/gim, formlink);
	} else if (content.match(/aim:/gim)) {
		content = content.replace(/aim:/gim, "/artikkel/");
	} else if (content.match(/skjema:/gim)) {
		content = content.replace(/skjema:/gim, formlink);
	} else if (content.match(/skjema_inline:/gim)) {
		content = content.replace(/aim:skjema:/gim, formlink);
	}

	return content;
};

export const urlParseCheck2 = (content) => {
	// let formlink = "/skjema/";
	let formlink = window.serverdata.configMeta.aim.skjema.url ? window.serverdata.configMeta.aim.skjema.url : "/skjema/";

	if (window.serverdata.configMeta.aim.skjema?.url) {
		formlink = window.serverdata.configMeta.aim.skjema.url;
	}

	const regex = /(?:aim:skjema:|aim:|skjema:|skjema_inline:)/gim;

	if (content.match(regex)) {
		return content.replace(regex, formlink);
	}

	return content;
};

export const getPageUrl = () => {
	const urldivert = location.pathname.slice(1).split(/\/(.+)/);
	let template = urldivert[0].length > 0 ? urldivert[0] : "frontpage";
	template = (template === "minkommune" || template === "mypage") ? "minside" : template;
	template = template.replace(/\/$/, ""); // removing trailing slash
	let contentid = "";
	if (template === "minside") {
		contentid = "mine";
	} else {
		contentid = urldivert[1] || "";
	}

	return { template, contentid, path: urldivert };
};

export const urlify = (string) => {
	if (string !== null) {
		return string
			.replace(/\s|,|-/gi, "_")
			.replace(/[æå]/gi, "a")
			.replace(/[ø]/gi, "o")
			.replace(/[_]{2,}/gi, "")
			.toLowerCase();
	}
	return string;
};

export const checkDocument = (content, related) => {
	const parse = $(`<div class='article-parse'>${content}</div>`);

	parse.find(".documentBlokk").each(function () {
		const id = $(this).attr("id");
		const doclink = $(this);
		$.each(related, (nr, obj) => {
			if (id === obj.contentId) {
				doclink.attr("href", obj.path).attr("target", "_blank");
			}
		});
	});

	return parse.html();
};

export const getObject = (id, cb) => {
	if (!id) {
		return;
	}
	let apiCall = `${window.apiUrl}/Public/articles/${id}?subscriptionId=${window.serverdata.configMeta.aim.clientId}&includeCategories=true&getRecursiveContent=true`;
	// apiCall = `${window.apiUrl}/PublicContentApi/find/${id}`;
	$.getJSON(apiCall).done((data) => {
		cb(data);
	});
};

export const articlesExtend = (article) => {
	if (article.metaObject && article.metaObject !== "mermeta" && article.metaObject !== "undefined" && typeof article.metaObject !== "undefined") {
		article.metaParsed = JSON.parse(decodeURIComponent(article.metaObject));
		if (article.metaParsed.currentDynamiskMalContent?.length) {
			article.metaDynamic = {};
			for (const cmc of article.metaParsed.currentDynamiskMalContent) {
				article.metaDynamic[cmc.title] = cmc.value;
			}
		}
	}

	return article;
};

export const setCorrectTemplate = (metaParsed) => {
	metaParsed.contentTypeId = metaParsed.contentTypeId === undefined ? metaParsed.id : metaParsed.contentTypeId;
	if (metaParsed.contentTypeId === "dd8d6460-5242-404f-a8dc-c75533bd06bd") {
		return "minside";
	}
	if (metaParsed.contentTypeId === "1bb71f41-4ee6-4394-b78f-3202e2f5eeda") {
		return "transportside";
	}
	if (metaParsed.contentTypeId === "882f5a94-f859-49d3-b3c8-50a7c70d0f1b") {
		return "forside";
	}
	if (metaParsed.contentTypeId === "e662f30f-ecd9-4974-8657-35b726365572") {
		return "temaside";
	}
	if (metaParsed.contentTypeId === "8ee596e3-98cc-43e0-b785-96cc6325773c") {
		// article with image
		return "mal_artikkel";
	}
	if (metaParsed.contentTypeId === "fd54728e-1956-433b-a33b-a7f95023dd37") {
		return "fokusartikkel";
	}
	if (metaParsed.contentTypeId === "5353f0bd-a7d5-42aa-aca2-ae17fe447f2f") {
		return "bti-forside";
	}
	if (metaParsed.contentTypeId === "ad378bce-c5d6-48de-8638-265e6428dc1d") {
		return "404";
	}
	if (metaParsed.contentTypeId === "453b9f75-ff2f-41cb-8504-04572637d756") {
		return "externalnavlink";
	}
	return false;
};

export const urlRest = (url) => {
	return `${window.location.search}${window.location.hash}`;
};

export const truncateWithElipsis = (text, length, useElipsis = true) => {
	if (text.length > length) {
		return `${text.substring(0, text.substring(0, length).lastIndexOf(" "))}...`;
	}
	return text;
};

export const isMobile = () => {
	return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0) < 768;
	// const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
	// // return (
	// //   /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
	// //     navigator.userAgent
	// //   ) || vw < 768
	// // );
	// const result = vw < 768;
	// return result;
};

export const checkValidPath = () => {
	const href = window.location.pathname;
	if (href.match(/\//g).length < 2) {
		return true; // path has only one level
	}
	if ((href.match(/.html$/g) || []).length > 0) {
		return false;
	}
	if ((href.match(/.htm$/g) || []).length > 0) {
		return false;
	}
	if ((href.match(/\/nav\//g) || []).length > 1) {
		return false; // more than one nav in path
	}
	if ((href.match(/\/rss\//g) || []).length > 1) {
		return false; // more than one nav in path
	}

	const findTerm = (term) => {
		if (href.includes(term)) {
			return href;
		}
	};

	switch (href) {
		case "/":
		case findTerm("/artikkel/"):
		case findTerm("/article/"):
		case findTerm("/nyhet/"):
		case findTerm("/news/"):
		case findTerm("/liste/"):
		case findTerm("/list/"):
		case findTerm("/event/"):
		case findTerm("/event_custom/"):
		case findTerm("/eventlist/"):
		case findTerm("/eventlist_custom/"):
		case findTerm("/kalender/"):
		case findTerm("/kalenderliste/"):
		case findTerm("/eventgrid/"):
		case findTerm("/skjema/"):
		case findTerm("/blokk/"):
		case findTerm("/fokus/"):
		case findTerm("/enhet/"):
		case findTerm("/unit/"):
		case findTerm("/nav/"):
		case findTerm("/sok"):
		case findTerm("/search"):
		case findTerm("/search2"):
		case findTerm("/frontpage"):
		case findTerm("/convertjson"):
		case findTerm("/aim-admin"):
			// case findTerm("/sitemap"):
			// case findTerm("/404"):
			// case findTerm("/rss"):
			// case findTerm("/personvernerklaering-og-informasjonskapsler"):
			// case findTerm("/tilgjengelighetserklaering"):
			return true;

		case findTerm("/aktuelt"):
		case findTerm("/nyheter"):
		case findTerm("episerver"):
		case findTerm("wp-content"):
		case findTerm("globalassets"):
		case findTerm("undefined"):
		case findTerm(":http:"):
		case findTerm(":https:"):
		case findTerm("/../"):
			return false;

		default:
			return false;
	}
};

export const addStringifiedComponent = async (componentTag, properties = {}) => {
	// Create an instance of the component
	const element = document.createElement(componentTag);

	// Apply any initial properties
	for (const key of Object.keys(properties)) {
		element[key] = properties[key];
	}

	// Append to an offscreen container (to ensure it's in the DOM)
	const offscreenContainer = document.createElement("div");
	offscreenContainer.style.position = "absolute";
	offscreenContainer.style.left = "-9999px";
	document.body.appendChild(offscreenContainer);
	offscreenContainer.appendChild(element);

	// Wait for the element to render
	await element.updateComplete;

	// Grab the rendered content
	const content = element.shadowRoot ? element.shadowRoot.innerHTML : element.innerHTML;

	// Clean up: remove the offscreen container from the body
	document.body.removeChild(offscreenContainer);

	return content;
};

export const renameJsonNode = (jsonObj, oldPath, newPath) => {
	const oldKeys = oldPath.split(".");
	const newKeys = newPath.split(".");

	let currentOld = jsonObj;
	let currentNew = jsonObj;

	// Traverse to the second last key in the old path
	for (let i = 0; i < oldKeys.length - 1; i++) {
		if (currentOld[oldKeys[i]] === undefined) {
			return jsonObj; // Old path does not exist
		}
		currentOld = currentOld[oldKeys[i]];
	}

	// Traverse to the second last key in the new path
	for (let i = 0; i < newKeys.length - 1; i++) {
		if (currentNew[newKeys[i]] === undefined) {
			currentNew[newKeys[i]] = {}; // Create path if it does not exist
		}
		currentNew = currentNew[newKeys[i]];
	}

	const oldKey = oldKeys[oldKeys.length - 1];
	const newKey = newKeys[newKeys.length - 1];

	if (Array.isArray(currentOld)) {
		for (const item of currentOld) {
			if (item[oldKey] !== undefined) {
				item[newKey] = item[oldKey];
				delete item[oldKey];
			}
		}


	} else if (currentOld[oldKey] !== undefined) {
		currentNew[newKey] = currentOld[oldKey];
		delete currentOld[oldKey];
	}

	return jsonObj;
};

const regexTestWithTimeout = (pattern, str, timeout) => {
	return new Promise((resolve, reject) => {
		const timer = setTimeout(() => {
			reject(new Error('Regex operation timed out'));
		}, timeout);

		try {
			const result = pattern.test(str);
			clearTimeout(timer);
			resolve(result);
		} catch (error) {
			clearTimeout(timer);
			reject(error);
		}
	});
};
